/** LoopBack filter: first name, last name, or email. `like` is case-insensitive. */
export const userSearchFilter = (search) => {
  const term = JSON.stringify(String(search || '').toLowerCase())
  return (
    '{"where":{"or":[' +
    '{"firstName":{"like":' + term + '}},' +
    '{"lastName":{"like":' + term + '}},' +
    '{"email":{"like":' + term + '}}]}}'
  )
}
